import { UseBaseMutationOptions } from '@/core/api/type'
import { Enable2FA } from '@/modules/profile/types'
import { enable2FA } from '../../services'
import { useMutation } from '@tanstack/react-query'
import { ProfileMutationKey } from '@/modules/profile/keys'

export default function useMutationEnable2FA(
	id: string,
	props?: UseBaseMutationOptions<void, Enable2FA>,
) {
	return useMutation({
		mutationKey: [ProfileMutationKey.Enable2FA, id],
		mutationFn: (params) => enable2FA(id, params),
		...props,
	})
}
